export const lightTheme = {
    body: '#FFF',
    text: '#19202a',
    toggleBorder: '#FFF',
    background: '#f0f1f5',
    primaryText: '#dc1d13',
    secondryText: '#747178',
    accent: '#dc1d13',
    shadeBg: '#D6D5D74D',
    background100: '#D8D9DD',
    green: '#00FF00'
    
}
export const darkTheme = {
    body: '#363537',
    text: '#f0f1f5',
    primaryText: '#dc1d13',
    secondryText: '#fff',
    toggleBorder: '#6B8096',
    background:  '#19202a',
    accent: '#dc1d13',
    shadeBg: '#363537',
    background100: '#3C414A',
    green: '#00FF00'

    
}

//${({ theme }) => theme.text}